import styled from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

import HideBalanceIcon from '../../../images/icon_hidebalance.svg'
import ShowBalanceIcon from '../../../images/icon_showbalance.svg'
import { brandConfig } from '../../../config/brandConfig'

export const StyledMyAccount = styled.div`
  color: ${themeStyles.colors.white.main};
  height: 50px;
  display: flex;
  align-items: center;
  font-size: ${brandConfig.fonts.text.body.size.mobile};
  width: 100%;
  padding: 0 1rem;
  cursor: pointer;

  img {
    vertical-align: middle;
  }

  ${themeMedia.desktop`
    height: 60px;
  `};

  > div {
    flex: 0 0 50%;
    width: 50%;
    text-align: left;
  }

  > div:nth-child(2) {
    text-align: right;
    color: ${themeStyles.colors.accentColors.secondary.main};
  }
`

export const StyledBalanceToggle = styled.button`
  flex: 0 1 18% !important;
  width: 28px;
  margin: 0 0.5rem;
  outline: none;
  background: url(${HideBalanceIcon}) 50% no-repeat;

  &.active {
    background: url(${ShowBalanceIcon}) 50% no-repeat;
  }
`

export const StyledAmountArea = styled.div`
  background-color: ${themeStyles.colors.darkGreys[4].main};
  width: 100%;
  padding: 1.5rem 1rem;
`

export const StyledWrapper = styled.div`
  background-color: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};
  width: 100%;
`

export const StyledRow = styled.div`
  display: flex;
  gap: 20px;

  > div > button {
    flex: 0 1 50%;
    line-height: 1.5;
  }

  div.slimmer-row {
    flex: 0 1 35%;
  }

  > div {
    flex: 0 1 60%;
    line-height: 1.5;
  }

  > div:nth-child(1) {
    font-size: ${brandConfig.fonts.text.body.size.mobile};
    text-align: left;
  }
  > div:nth-child(2) {
    text-align: right;
    justify-content: flex-end;
  }

  &.with-margins {
    margin: 1.5em 0 0.8em;
  }

  &.no-gap {
    gap: 0;
  }

  &.space-between {
    justify-content: space-between;
  }
`

export const StyledSubRow = styled.div`
  display: flex;
  font-size: ${brandConfig.fonts.text.body.size.mobile};

  > div:nth-child(1) {
    text-align: left;
  }
  > div:nth-child(2) {
    text-align: right;
    justify-content: flex-end;
  }
`
export const StyledChipsButton = styled.div`
  background-color: ${themeStyles.colors.black.main};
  border-radius: 36px;
  line-height: 1.3;
  font-size: ${brandConfig.fonts.text.body.size.mobile};
  padding: 0.3rem 0.6rem 0.5rem;
  margin: 0.5rem auto;
  cursor: pointer;
  text-align: center;
  position: relative;

  > img {
    position: absolute;
    left: 10px;
    &.left-icon {
      top: 50%;
      transform: translateY(-50%);
      height: 22.5px;
    }

    &.right-icon {
      float: right;
      margin: 0.25rem 0 0 0;
      position: initial;
    }
  }
`
